import { render, staticRenderFns } from "./editForm.vue?vue&type=template&id=6cd10f20&scoped=true&"
import script from "./editForm.vue?vue&type=script&lang=js&"
export * from "./editForm.vue?vue&type=script&lang=js&"
import style0 from "./editForm.vue?vue&type=style&index=0&id=6cd10f20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd10f20",
  null
  
)

export default component.exports